import { AppProps } from 'next/app';
import { DefaultSeo } from 'next-seo';
import { PropsWithChildren } from 'react';

import { NoShellPageProps } from '@/cutils/page-context/server-side-props';

import ErrorBoundary from '../Error/ErrorBoundary';
import { ErrorServerError } from '../Error/ErrorServerError';
import { HTMLNoShellHead } from '../HTMLHead/HTMLNoShellHead';

export function NoShellLayout({
	pageProps,
	children,
	nofollow,
	className = '',
}: PropsWithChildren<Pick<AppProps<NoShellPageProps>, 'pageProps'> & { nofollow: boolean; className?: string }>) {
	const baseUrl = pageProps.environment.constants.BASE_URL ?? '';

	return (
		<>
			{/* add `noindex` on non-prod environments */}
			{nofollow && <DefaultSeo dangerouslySetAllPagesToNoFollow={true} dangerouslySetAllPagesToNoIndex={true} />}

			{/* Injects static meta tags into the `<head />`. */}
			<HTMLNoShellHead baseUrl={baseUrl} />

			<main className={className}>
				<ErrorBoundary fallback={<ErrorServerError />}>{children}</ErrorBoundary>
			</main>
		</>
	);
}
